import React from 'react';
import styled from 'styled-components';
import Button, { ButtonType } from '~/components/shared/Button/button';
import Card from '~/components/shared/Card/Card';
import Image from '~/components/shared/Image/Image';
import useTranslate from '~/hooks/useTranslate';
import { useSelector } from 'react-redux';
import { ApiStatus } from '~/store/types/sharedTypes';
import { RootState } from '~/store';
import SpinnerLinear from '~/components/shared/Spinner/SpinnerLinear';
import { Body, H7 } from '@qred/components-library';

const HeaderContainer = styled.div`
  margin-bottom: 1em;
`;

const FlexRow = styled.div`
  display: flex;
  align-items: center;
`;

const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
  @media (orientation: landscape) {
    max-width: 75%;
  }
`;

const ImageContainer = styled.div`
  margin: 0 1em;
  width: 25%;
  flex-basis: 20em;

  @media (orientation: landscape) {
    position: absolute;
    right: 0;
    top: 1em;
    bottom: 1em;
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
  }

  @media (orientation: portrait) {
    height: 50%;
    margin-right: 0;
  }
`;

const ButtonContainer = styled.div`
  @media (orientation: landscape) {
    width: 14em;
    align-self: flex-start;
  }
`;

interface Props {
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const EskatCard: React.FC<Props> = (props) => {
  const translate = useTranslate();
  const { apiStatus } = useSelector((state: RootState) => state.eskat);

  return (
    <Card>
      <FlexRow>
        <FlexColumn>
          <HeaderContainer>
            <H7>{translate('EskatCard.Title')}</H7>
          </HeaderContainer>
          <Body size="lg">{translate('EskatCard.Text')}</Body>
        </FlexColumn>
        <ImageContainer>
          <Image src="success.png" />
        </ImageContainer>
      </FlexRow>
      <ButtonContainer>
        <Button
          fullWidth
          type={ButtonType.Outlined}
          onClick={props.onClick}
          mt={1}
        >
          {apiStatus === ApiStatus.Started ? (
            <SpinnerLinear filled />
          ) : (
            translate('EskatCard.ButtonText')
          )}
        </Button>
      </ButtonContainer>
    </Card>
  );
};

export default EskatCard;
